module.exports = __webpack_public_path__ + "static/media/html5-plain.2fd6cc98.svg";